import { render, staticRenderFns } from "./AccessProcess.vue?vue&type=template&id=ec7dfe60&scoped=true&"
import script from "./AccessProcess.vue?vue&type=script&lang=ts&"
export * from "./AccessProcess.vue?vue&type=script&lang=ts&"
import style0 from "./AccessProcess.vue?vue&type=style&index=0&id=ec7dfe60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7dfe60",
  null
  
)

export default component.exports